// Module
var code = "<dropdown-field v-if=\"form\" @change=\"change\" :null-is-dirty=\"nullIsDirty\" :disabled=\"disabled\" :label=\"label ? label : name\" :value.sync=\"form[field]\" :validation=\"form.validation[field]\" :options=\"enumeration ? optionsFromEnum : options\"></dropdown-field> ";
// Exports
export default code;